import {createPostMutation} from '../hooks/useQuery'
import type {ApiBookingDriversResponse} from '../components/BookingDriverTable'
import type {OptionTuples} from '../helpers/react-helpers'


type AlertInfo = {
    label: string
    color: string
}

// https://github.com/kymark-innovations/kymark-bookings/issues/711#issuecomment-907880961
// Also in config/enums.php and migrations/2021_09_04_181831_segment_alert.php
export const DRIVER_ALERTS: [key: string, info: AlertInfo][] = [
    ['ON_ROUTE', {label: "On Route to PU", color: '#DB4E4E'}],
    ['ARRIVED', {label: "Arrived at PU", color: '#002445'}],
    ['PASSENGER_IN_VEHICLE', {label: "Passenger Received", color: '#EE5B2A'}],
    ['DEPARTED', {label: "Departed PU", color: '#05C1EF'}],
    ['ON_ROUTE_STOPS', {label: "On Route to Stops", color: '#3E8FC1'}],
    ['STANDBY', {label: "Standby", color: '#696969'}],
    ['ON_ROUTE_DO', {label: "On Route to DO", color: '#F2A215'}],
    ['ARRIVED_DO', {label: "Arrived at DO", color: '#8FC224'}],
    ['PASSENGER_EXITED', {label: "Passenger Exited", color: '#3E9971'}],
    ['COMPLETED', {label: "Complete", color: '#01A75F'}],
]

export const ALERT_OPTIONS: OptionTuples = DRIVER_ALERTS.map(([id, {label}]) => [id, label])

/** @deprecated */
export const ALERT_MAP = Object.fromEntries(ALERT_OPTIONS)
export const ALERT_MAP_FULL = Object.fromEntries(DRIVER_ALERTS)

type SendAlertRequest = {
    segmentId: number
    alertId: string
}

// see BookingsController::sendDriverAlert
type SendAlertResponse = {
    smsRecipient?: string
    smsError?: string
    tableData: ApiBookingDriversResponse
}


export const useSendAlert = createPostMutation<SendAlertRequest, SendAlertResponse>('twilio.sendDriverAlert')
